import { formatText, formatTitle } from '@/utils/common'

export default {
  data() {
    return {
      pageInfo: {
        aliPayment: {
          title: '会员支付宝流水查询',
          exportUrl: '8',
          col: [
            { field: 'order_no', title: '订单编号', width: 230, showTitle: true },
            { field: 'order_time', title: '下单日期', width: 160, showTitle: true },
            { field: 'order_status', title: '状态', width: 60, formatter(rowData) {
              return formatText(rowData.order_status, ['待付款', '待付款', '已付款'], '', '待付款')
            } },
            { field: 'pay_type', title: '支付方式', width: 80, formatter(rowData) {
              return formatText(rowData.pay_type, ['', '线下转账', '支付宝']) // 1线下转账；2支付宝
            } },
            { field: 'cust_no', title: '企业编码', width: 80, showTitle: true },
            { field: 'cust_name', title: '下单用户', width: 220, showTitle: true },
            { field: 'order_memo', title: '服务内容', width: 140, showTitle: true },
            { field: 'order_money', title: '订单金额', width: 80, showTitle: true }
          ],
          layout: ['code', 'name', 'date', 'export']
        },
        vipPayment: {
          title: '会员转账交易审核',
          exportUrl: '9',
          col: [
            { field: 'operation', title: '操作', width: 60, componentName: 'operateTrad' },
            { field: 'order_no', title: '订单编号', width: 230, showTitle: true },
            { field: 'order_time', title: '下单日期', width: 160, showTitle: true },
            { field: 'check_status', title: '状态', width: 60, formatter(rowData) {
              return formatText(rowData.check_status, ['待审核', '已付款'], '', '待审核')
            } },
            { field: 'pay_type', title: '支付方式', width: 80, formatter(rowData) {
              return formatText(rowData.pay_type, ['', '线下转账', '支付宝']) // 1线下转账；2支付宝
            } },
            { field: 'cust_no', title: '企业编码', width: 80, showTitle: true },
            { field: 'cust_name', title: '下单用户', width: 220, showTitle: true },
            { field: 'order_memo', title: '服务内容', width: 140, showTitle: true },
            { field: 'order_money', title: '订单金额', width: 80, showTitle: true }
          ],
          layout: ['code', 'name', 'date', 'export']
        },
        ukeyPayment: {
          title: 'UKey付款流水查询',
          exportUrl: '1',
          col: [
            { field: 'order_id', title: '订单编号', width: 230, showTitle: true },
            { field: 'create_time', title: '下单日期', width: 160, showTitle: true },
            { field: 'buy_status', title: '状态', width: 60, formatter(rowData) {
              return formatText(rowData.buy_status, ['待付款', '已付款'])
            } },
            { field: 'buy_type', title: '支付方式', width: 80, formatter(rowData) {
              return formatText(rowData.buy_type, ['支付宝', '微信', '线下转账'])
            } },
            { field: 'cust_no', title: '企业编码', width: 80, showTitle: true },
            { field: 'cust_name', title: '下单用户', width: 220, showTitle: true },
            { field: 'order_content', title: '服务内容', width: 150, showTitle: true },
            { field: 'order_money', title: '订单金额', width: 80, showTitle: true }
          ],
          layout: ['code', 'name', 'date', 'export']
        },
        tranService: {
          title: '交易服务费流水查询',
          exportUrl: '2',
          col: [
            { field: 'account_num', title: '财务流水单号', width: 140, showTitle: true },
            { field: 'statement_num', title: '业务流水单号', width: 140, showTitle: true },
            { field: 'sct_no', title: '合同编号', width: 200, showTitle: true },
            { field: 'payment_date', title: '付款日期', width: 160, showTitle: true },
            { field: 't_agent_info_agent_name_fukuanfang', title: '付款方渠道', width: 160, showTitle: true },
            { field: 'payer', title: '付款方', width: 220, showTitle: true },
            { field: 't_agent_info_agent_name_shoukuanfang', title: '收款方渠道', width: 160, showTitle: true },
            { field: 'receiver', title: '收款方', width: 220, showTitle: true },
            { field: 'money', title: '服务费金额', width: 100, showTitle: true },
            { field: 'type', title: '类型', width: 60, formatter(rowData) {
              return formatText(rowData.type, ['', '收款', '付款', '解冻', '冻结', '服务费'])
            } },
            { field: 'zhuangtai', title: '状态', width: 60 }
          ],
          layout: ['payer', 'payee', 'date', 'export', 't_agent_info_agent_name_fukuanfang', 't_agent_info_agent_name_shoukuanfang']
        },
        recharge: {
          title: '充值流水查询',
          exportUrl: '3',
          receiptType: '1',
          idLabel: 'statement_num',
          codeLabel: 'cust_no',
          col: [
            { field: 'operation', title: '操作', width: 70, componentName: 'operateTrad' },
            { field: 'statement_num', title: '流水单号', width: 140, showTitle: true },
            { field: 'cust_no', title: '企业编码', width: 80, showTitle: true },
            { field: 't_agent_info_agent_name', title: '渠道', width: 160, showTitle: true },
            { field: 'payer', title: '付款方', width: 220, showTitle: true },
            { field: 'payer_account', title: '付款账号', width: 160, showTitle: true },
            { field: 'recharge_date', title: '充值日期', width: 160, showTitle: true },
            { field: 'recharge_amount', title: '充值金额', width: 100, showTitle: true },
            { field: 'memo', title: '备注', width: 180, showTitle: true }
          ],
          layout: ['code', 'payer', 'date', 'export', 't_agent_info_agent_name']
        },
        withdrawal: {
          title: '提现流水查询',
          exportUrl: '4',
          receiptType: '2',
          idLabel: 'statement_num',
          codeLabel: 'cust_no',
          col: [
            { field: 'operation', title: '操作', width: 70, componentName: 'operateTrad' },
            { field: 'statement_num', title: '流水单号', width: 140, showTitle: true },
            { field: 'cust_no', title: '企业编码', width: 100, showTitle: true },
            { field: 't_agent_info_agent_name', title: '渠道', width: 160, showTitle: true },
            { field: 'receiver', title: '收款方', width: 220, showTitle: true },
            { field: 'bankname', title: '收款银行', width: 120, showTitle: true },
            { field: 'receiver_account', title: '收款账号', width: 140, showTitle: true },
            { field: 'withdraw_date', title: '提现日期', width: 160, showTitle: true },
            { field: 'withdraw_type', title: '状态', width: 60, formatter(rowData, index, pageIndex, field) {
              return formatText(rowData.withdraw_type, ['成功', '失败', '', '', '', '待处理', '处理中'])
            } },
            { field: 'withdraw_amount', title: '提现金额', width: 100, showTitle: true },
            { field: 'memo', title: '备注', width: 120, showTitle: true }
          ],
          layout: ['code', 'payee', 'date', 'export', 't_agent_info_agent_name']
        },
        payment: {
          title: '付款流水查询',
          exportUrl: '5',
          receiptType: '3',
          idLabel: 'account_num',
          codeLabel: 'sct_no',
          col: [
            { field: 'operation', title: '操作', width: 70, componentName: 'operateTrad' },
            { field: 'account_num', title: '财务流水单号', width: 140, showTitle: true },
            { field: 'statement_num', title: '业务流水单号', width: 140, showTitle: true },
            { field: 'sct_no', title: '合同编号', width: 200, showTitle: true },
            { field: 'type', title: '类型', width: 60, formatter(rowData) {
              return formatText(rowData.type, ['', '收款', '付款', '解冻', '冻结', '服务费', '', '', '', '冻结'])
            } },
            { field: 't_agent_info_agent_name_fukuanfang', title: '付款方渠道', width: 160, showTitle: true },
            { field: 'payer', title: '付款方', width: 220, showTitle: true },
            { field: 'payer_account', title: '付款账号', width: 140, showTitle: true },
            { field: 't_agent_info_agent_name_shoukuanfang', title: '收款方渠道', width: 160, showTitle: true },
            { field: 'receiver', title: '收款方', width: 220, showTitle: true },
            { field: 'receiver_account', title: '收款账号', width: 140, showTitle: true },
            { field: 'money', title: '金额', width: 100, showTitle: true },
            { field: 'payment_date', title: '付款日期', width: 160, showTitle: true },
            { field: 'balance', title: '账户余额', width: 100, showTitle: true }
          ],
          layout: ['payer', 'payee', 'date', 'export', 't_agent_info_agent_name_fukuanfang', 't_agent_info_agent_name_shoukuanfang']
        },
        receivable: {
          title: '收款流水查询',
          exportUrl: '6',
          receiptType: '4',
          idLabel: 'account_num',
          codeLabel: 'sct_no',
          col: [
            { field: 'operation', title: '操作', width: 70, componentName: 'operateTrad' },
            { field: 'account_num', title: '财务流水单号', width: 140, showTitle: true },
            { field: 'statement_num', title: '业务流水单号', width: 140, showTitle: true },
            { field: 'sct_no', title: '合同编号', width: 200, showTitle: true },
            { field: 'type', title: '类型', width: 60, formatter(rowData) {
              return formatText(rowData.type, ['', '收款', '付款', '解冻', '冻结', '服务费'])
            } },
            { field: 't_agent_info_agent_name_fukuanfang', title: '付款方渠道', width: 160, showTitle: true },
            { field: 'payer', title: '付款方', width: 220, showTitle: true },
            { field: 'payer_account', title: '付款账号', width: 140, showTitle: true },
            { field: 't_agent_info_agent_name_shoukuanfang', title: '收款方渠道', width: 160, showTitle: true },
            { field: 'receiver', title: '收款方', width: 220, showTitle: true },
            { field: 'receiver_account', title: '收款账号', width: 140, showTitle: true },
            { field: 'money', title: '金额', width: 100, showTitle: true },
            { field: 'payment_date', title: '付款日期', width: 160, showTitle: true },
            { field: 'balance', title: '账户余额', width: 100, showTitle: true }
          ],
          layout: ['payer', 'payee', 'date', 'export', 't_agent_info_agent_name_fukuanfang', 't_agent_info_agent_name_shoukuanfang']
        },
        sameTradeDetail: {
          title: '账户互转流水查询',
          exportUrl: '7',
          receiptType: '5',
          idLabel: 'account_num',
          codeLabel: 'sct_no',
          col: [
            { field: 'operation', title: '操作', width: 90, componentName: 'operateTrad' },
            { field: 'statement_num', title: '流水单号', width: 160, showTitle: true },
            { field: 'cust_no', title: '企业编码', width: 90, showTitle: true },
            { field: 't_agent_info_agent_name', title: '渠道', width: 160, showTitle: true },
            { field: 'company_name', title: '企业名称', width: 220, showTitle: true },
            { field: 'type', title: '转账方式', width: 90, formatter(rowData) {
              return formatText(rowData.type, ['', '收转付', '付转收'])
            } },
            { field: 'payment_date', title: '转账日期', width: 170, showTitle: true },
            { field: 'money', title: '转账金额', width: 130, showTitle: true },
            { field: 'memo', title: '备注', width: 300, showTitle: true }
          ],
          layout: ['code', 'name', 'type', 'date', 'export', 't_agent_info_agent_name']
        },
        reportSearch: {
          title: '调研报告流水查询',
          exportUrl: '10',
          receiptType: '6',
          idLabel: 'account_num',
          codeLabel: 'sct_no',
          col: [
            { field: 'order_no', title: '订单编号', width: 120, showTitle: true },
            { field: 'create_time', title: '订单日期', width: 160, showTitle: true },
            { field: 'pay_type', title: '支付方式', width: 80, formatter(rowData) {
              return formatText(rowData.pay_type, ['未指定', '支付宝', '微信', '会员赠送'])
            } },
            { field: 't_agent_info_agent_name', title: '渠道', width: 160, showTitle: true },
            { field: 'cust_name', title: '企业名称', width: 220, showTitle: true },
            { field: 'hy_level', title: '会员类型', width: 80, formatter(rowData) {
              return formatText(rowData.hy_level, ['免费会员', '初级会员', '中级会员 ', '高级会员'])
            } },
            { field: 'price_pay', title: '订单金额', width: 80, showTitle: true },
            { field: 'id', title: '报告ID', width: 80, showTitle: true },
            { field: 'hall_id', title: '类型', width: 80, formatter(rowData) {
              return Number(rowData.hall_id) === 100 ? '品类调研' : (Number(rowData.hall_id) === 200 ? '终端调研' : '其他未开发')
            } },
            { field: 'area_type', title: '子类', width: 80, formatter(rowData) {
              return Number(rowData.area_type) === 1 ? '城市调研' : '区县调研'
            } },
            { field: 'order_name', title: '服务内容', width: 220, showTitle: true },
            { field: 'depart_disease', title: '疾病大类', width: 100, showTitle: true },
            { field: 'disease_name', title: '疾病小类', width: 100, showTitle: true },
            { field: 'p_province', title: '省', width: 80, showTitle: true },
            { field: 'p_city', title: '市', width: 80, showTitle: true },
            { field: 'p_district', title: '区县', width: 80, showTitle: true },
            { field: 'choose_date', title: '时间', width: 120, showTitle: true }
          ],
          layout: ['name', 'payType', 'date', 'export', 't_agent_info_agent_name']
        },
        reportTerminal: {
          title: '调研报告流水查询',
          exportUrl: '22',
          receiptType: '6',
          idLabel: 'account_num',
          codeLabel: 'sct_no',
          col: [
            { field: 'order_no', title: '订单编号', width: 120, showTitle: true },
            { field: 'create_time', title: '订单日期', width: 160, showTitle: true },
            { field: 'pay_type', title: '支付方式', width: 80, formatter(rowData) {
              return formatText(rowData.pay_type, ['未指定', '支付宝', '微信', '会员赠送'])
            } },
            { field: 't_agent_info_agent_name', title: '渠道', width: 160, showTitle: true },
            { field: 'cust_name', title: '企业名称', width: 220, showTitle: true },
            { field: 'hy_level', title: '会员类型', width: 80, formatter(rowData) {
              return formatText(rowData.hy_level, ['免费会员', '初级会员', '中级会员 ', '高级会员'])
            } },
            { field: 'price_pay', title: '订单金额', width: 80, showTitle: true },
            { field: 'id', title: '报告ID', width: 80, showTitle: true },
            { field: 'hall_id', title: '类型', width: 80, formatter(rowData) {
              return Number(rowData.hall_id) === 100 ? '品类调研' : (Number(rowData.hall_id) === 200 ? '终端调研' : '其他未开发')
            } },
            { field: 'area_type', title: '子类', width: 110, formatter(rowData) {
              return Number(rowData.area_type) === 1 ? '城市医院调研' : '单家医院调研'
            } },
            { field: 'order_name', title: '服务内容', width: 220, showTitle: true },
            { field: 'choose_date', title: '时间', width: 120, showTitle: true },
            { field: 'p_province', title: '省', width: 80, showTitle: true },
            { field: 'p_city', title: '市', width: 80, showTitle: true }
          ],
          layout: ['name', 'payType', 'date', 'export', 't_agent_info_agent_name']
        },
        receivableAccount: { // 对账中心
          title: '收款流水查询',
          exportUrl: '11',
          receiptType: '4',
          idLabel: 'account_num',
          codeLabel: 'sct_no',
          col: [
            { field: 'operation', title: '操作', width: 70, componentName: 'operateTrad' },
            { field: 'account_num', title: '财务流水单号', width: 140, showTitle: true },
            { field: 'statement_num', title: '业务流水单号', width: 140, showTitle: true },
            { field: 'sct_no', title: '合同编号', width: 200, showTitle: true },
            { field: 'type', title: '类型', width: 60, formatter(rowData) {
              return formatText(rowData.type, ['', '收款', '付款', '解冻', '冻结', '服务费'])
            } },
            { field: 't_agent_info_agent_name_fukuanfang', title: '付款方渠道', width: 160, showTitle: true },
            { field: 'payer', title: '付款方', width: 220, showTitle: true },
            { field: 'payer_account', title: '付款账号', width: 140, showTitle: true },
            { field: 't_agent_info_agent_name_shoukuanfang', title: '收款方渠道', width: 160, showTitle: true },
            { field: 'receiver', title: '收款方', width: 220, showTitle: true },
            { field: 'receiver_account', title: '收款账号', width: 140, showTitle: true },
            { field: 'money', title: '金额', width: 100, showTitle: true },
            { field: 'process_fee', title: '手续费', width: 100, showTitle: true },
            { field: 'payment_date', title: '付款日期', width: 160, showTitle: true },
            { field: 'balance', title: '账户余额', width: 100, showTitle: true }
          ],
          layout: ['payer', 'payee', 'date', 'export', 't_agent_info_agent_name_fukuanfang', 't_agent_info_agent_name_shoukuanfang']
        }
      }
    }
  },
  methods: {
    // 初始化页面参数
    initPage() {
      const pageName = this.$route.name
      // === 'reportTerminal' ? 'reportSearch' : this.$route.name
      this.title = this.pageInfo[pageName].title
      this.exportUrl = this.pageInfo[pageName].exportUrl
      this.receiptType = this.pageInfo[pageName].receiptType
      this.col = this.pageInfo[pageName].col.map(item => {
        item.titleAlign = 'left'
        item.columnAlign = 'left'
        item.isResize = true
        if (item.showTitle !== undefined && item.showTitle) {
          item.formatter = function(rowData, index, pageIndex, field) {
            return formatTitle(rowData[field])
          }
        }
        return item
      })
      this.searchLayout = this.pageInfo[pageName].layout
      // 清空搜索参数
      this.queryNo = ''
      this.queryName = ''
      this.queryTime = []
      this.queryPayer = ''
      this.queryPayee = ''
    }
  }
}
